// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Reply = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Reply = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Reply = _exports.Reply = function Reply(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M2.34843 8.38749L7.28841 3.16248C7.70008 2.72831 8.32669 2.59088 8.87919 2.81254C9.43419 3.03338 9.7925 3.5617 9.79167 4.15837V6.46428C15.1725 6.62511 18.125 8.8992 18.125 12.9084C18.125 14.285 17.7751 15.6567 17.1401 16.7709C16.9518 17.1017 16.6168 17.2917 16.2551 17.2917C16.1651 17.2917 16.0717 17.2801 15.98 17.2551C15.5284 17.1326 15.2284 16.7351 15.2334 16.2651C15.2467 15.2526 15.1425 14.5118 14.585 13.9468C13.8316 13.1834 12.22 12.7676 9.79085 12.7076V14.996C9.79169 15.5926 9.43338 16.1218 8.87838 16.3426C8.32588 16.5634 7.69926 16.4258 7.2876 15.9917L2.34741 10.7666C1.71824 10.1 1.71843 9.05499 2.34843 8.38749ZM3.25663 9.90849L8.19661 15.1325C8.27495 15.215 8.36091 15.2034 8.41675 15.1809C8.47341 15.1584 8.54167 15.1076 8.54167 14.996V12.075C8.54167 11.73 8.82167 11.45 9.16667 11.45C12.3808 11.45 14.3859 11.9643 15.4751 13.0685C16.1234 13.7251 16.3667 14.5042 16.4492 15.3034C16.7267 14.5617 16.875 13.7376 16.875 12.9076C16.875 8.60672 12.6833 7.70431 9.16667 7.70431C8.82167 7.70431 8.54167 7.42431 8.54167 7.07931V4.15755C8.54167 4.04672 8.47425 3.99593 8.41675 3.97343C8.39425 3.96426 8.36577 3.95675 8.33577 3.95675C8.29161 3.95675 8.24328 3.97248 8.19661 4.02165L3.25663 9.24667C3.0808 9.43166 3.0808 9.72266 3.25663 9.90849Z",
      fill: "#212B36"
    }));
  };
});
